import { css } from "@emotion/css";
import { GitHubIcon, OpenIdConnectIcon } from "@octopusdeploy/design-system-octopus-components";
import { space } from "@octopusdeploy/design-system-tokens";
import type { IssuerType } from "./getIssuerType";
type IssuerTypeLogoProps = {
    issuerType: IssuerType;
    small?: boolean;
};
export function IssuerTypeLogo({ issuerType, small }: IssuerTypeLogoProps) {
    const styles = {
        container: css({
            display: "flex",
            height: small ? space[32] : space[48],
            width: small ? space[32] : space[48],
            fontSize: small ? space[32] : space[48],
        }),
    };
    return <div className={styles.container}>{issuerType === "GitHubActions" ? <GitHubIcon fontSize="inherit"/> : <OpenIdConnectIcon />}</div>;
}
